import React from 'react';

const NoResultStyle = {
    width: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontSize: "2rem"
}

function NoResult() {
    return (
        <div style={NoResultStyle}>搜尋後無相關資料</div>
    );
}

export default NoResult;